import React from 'react';
import { Box, Menu, MenuItem, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStorefrontContext } from 'context/StorefrontContext';
import { NavItem } from 'types/storefront';
import { ROUTES } from 'config/routes';

const defaultNav: NavItem[] = [
  { labelKey: 'nav.catalog', url: ROUTES.CATALOG },
  { labelKey: 'nav.promotions', url: ROUTES.PROMOTIONS },
  { labelKey: 'nav.news', url: ROUTES.NEWS },
  { labelKey: 'nav.brands', url: ROUTES.BRANDS },
];

interface MegaMenuProps {
  uppercase?: boolean;
}

const MegaMenu: React.FC<MegaMenuProps> = ({ uppercase = false }) => {
  const { t } = useTranslation('common');
  const { navigation, features } = useStorefrontContext();
  const [anchor, setAnchor] = React.useState<null | HTMLElement>(null);

  const items = navigation.header.length > 0 ? navigation.header : defaultNav;

  const filtered = items.filter((item) => {
    if (item.url.includes('promociones') && !features.promotionsEnabled) return false;
    if (item.url.includes('marcas') && !features.brandsEnabled) return false;
    return true;
  });

  const labelFor = (item: NavItem) => item.label || (item.labelKey ? t(item.labelKey) : item.url);

  const buttonSx = uppercase
    ? {
        fontWeight: 600,
        letterSpacing: 0.4,
        textTransform: 'uppercase' as const,
        whiteSpace: 'nowrap' as const,
        color: 'text.primary',
      }
    : undefined;

  return (
    <Box display="flex" gap={1} flexWrap={uppercase ? 'nowrap' : 'wrap'}>
      {filtered.map((item) =>
        item.children?.length ? (
          <Box key={item.url}>
            <Button onClick={(e) => setAnchor(e.currentTarget)} sx={buttonSx}>
              {labelFor(item)}
            </Button>
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
              {item.children.map((child) => (
                <MenuItem
                  key={child.url}
                  component={RouterLink}
                  to={child.url}
                  onClick={() => setAnchor(null)}
                >
                  {labelFor(child)}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        ) : (
          <Button key={item.url} component={RouterLink} to={item.url} color="inherit" sx={buttonSx}>
            {labelFor(item)}
          </Button>
        )
      )}
    </Box>
  );
};

export default MegaMenu;
